import { createStore } from 'vuex';
import * as user from '../modules/user';
import * as generic from '../modules/generic';
import * as productComparison from '../modules/product-comparison';

const store = createStore({
  modules: {
    user,
    generic,
    productComparison
  }
});

user.init(store);
generic.init(store);

export default store;
